import {WindowEvents} from "../../global/kendoWindows";

export default function () {
  WindowEvents.onOpenEvents.CapExCreateWindow = function () {
    let $window = this.element;
    let $continueButton = $window.find('.js-continue-button');
    $continueButton.unbind('click');
    $continueButton.click(function () {
      let type = $('[name=capExType]:checked').val()
      if (type == null) {
        $window.find('.js-type-error').show();
        return;
      }
      window.location = `/Finance/CapitalExpenditures/${type}Request`;
    });
  }
}